import moment from "moment";
import { ModelBase } from "../abstract/model-base.model";
import { CustomProfile } from "../authorization/custom-profile.model";
import { Profile } from "../authorization/profile.model";

export class ApiKey extends ModelBase {

    static override CLASS_NAME: string = 'ApiKey';

    private _created!: moment.Moment;
    private _key!: string;
    private _name!: string;
    private _prefix!: string;
    private _profile?: Profile;
    private _customProfile?: CustomProfile;
    private _revoked!: boolean;

    public get created(): moment.Moment {
        return this._created;
    }

    public set created(value: any) {
        this._setValue('_created', value, 'datetime');
    }

    public get displayRole(): string {
        if (this.profile) {
            return this.profile.label!;
        } else if (this.customProfile) {
            return this.customProfile.label!;
        } else {
            return 'Aucun';
        }
    }

    public get key(): string {
        return this._key;
    }

    public set key(value: any) {
        this._setValue('_key', value, 'string');
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: any) {
        this._setValue('_name', value, 'string');
    }

    public get prefix(): string {
        return this._prefix;
    }

    public set prefix(value: any) {
        this._setValue('_prefix', value, 'string');
    }

    public get profile(): Profile | undefined {
        return this._profile;
    }

    public set profile(value: Profile | undefined) {
        this._setValue('_profile', value, 'Profile');
    }

    public get customProfile(): CustomProfile | undefined {
        return this._customProfile;
    }

    public set customProfile(value: CustomProfile | undefined) {
        this._setValue('_customProfile', value, 'CustomProfile');
    }

    public get revoked(): boolean {
        return this._revoked;
    }

    public set revoked(value: any) {
        this._setValue('_revoked', value, 'boolean');
    }

}
